module.exports = __webpack_public_path__ + "static/media/downloadOrganization.f2b47884.svg";